import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Modal, Row, Col } from 'react-bootstrap';
import { DeleteButton, DivFiles, ModalPreview } from './styles';
import { ConsumoAPI_FileDelete, ConsumoAPI_FileUpload } from '../../../backend/ConsumoAPI';
import DocxViewer from '../DocXViewer';
import TextViewer from '../TextViewer';
import ExcelViewer from '../ExcelViewer';
import IconComponent from '../Icons';

function UploadFiles({ onDropEvent, onDeleteEvent, value, disabled, disabledDelete=false }) {
    const [previewModalShow, setPreviewModalShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [files, setFiles] = useState(value || []); // Garante que o estado inicial seja um array

    useEffect(() => {
        setFiles(value || []); // Sincroniza o estado `files` com `value`
    }, [value]);

    const handleDeleteFile = async(file, index) => {
        if (disabled) {
            return;
        }

        const retDelete = await ConsumoAPI_FileDelete(file.filename);

        if (retDelete.error === "00") {
            const filesSelect = await onDeleteEvent(index);
            
            if (filesSelect){
                setFiles(filesSelect);
            }
        }
    };

    const handlePreviewModal = (file) => {
        const fileExtension = getFileExtension(file.originalname);
        setSelectedFile(file);
        
        if (fileExtension.toLowerCase() !== 'pdf' && !isImageFile(fileExtension))
            setPreviewModalShow(true);
    };

    const hidePreviewModal = () => {
        setSelectedFile(null);
        setPreviewModalShow(false);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles, fileRejections, evento) => { onDropZone(acceptedFiles, fileRejections, evento) },
        preventDropOnDocument: true,
        multiple: true,
    });

    const sanitizeFileName = (name) => {
        return name
            .normalize('NFD') // separa acentos
            .replace(/[\u0300-\u036f]/g, '') // remove acentos
            .replace(/[^a-zA-Z0-9.\-_]/g, '_'); // substitui tudo que não for letra, número, ponto, hífen ou underline por "_"
    };

    const onDropZone = async (acceptedFiles, fileRejections, evento) => {
        const sanitizedFiles = acceptedFiles.map(file => {
            const sanitizedName = sanitizeFileName(file.name);

            // Cria um novo objeto File com o nome sanitizado
            return new File([file], sanitizedName, {
                type: file.type,
                lastModified: file.lastModified,
            });
        });

        const filesSelect = await onDropEvent(sanitizedFiles, fileRejections, evento);

        if (filesSelect) {
            setFiles(filesSelect);
        }
    };
    // const onDropZone = async(acceptedFiles, fileRejections, evento) => {
    //     const filesSelect = await onDropEvent(acceptedFiles, fileRejections, evento)

    //     if (filesSelect){
    //         setFiles(filesSelect);
    //     }
    // }

    const renderFilePreview = () => {
        const fileExtension = getFileExtension(selectedFile.originalname);
        const filePathComplete = `${process.env.PUBLIC_URL}/uploads/${selectedFile.filename}`
        const fileNameComplete = selectedFile.originalname
    
        if (isImageFile(fileExtension)) {
            window.open(filePathComplete, '_blank');
			setSelectedFile(null);
        } else if (fileExtension.toLowerCase() === 'pdf') {
            window.open(filePathComplete, '_blank');
			setSelectedFile(null);
        } else if (fileExtension.toLowerCase() === 'docx' ) {
            return <DocxViewer filePath={filePathComplete} fileName={fileNameComplete}></DocxViewer>
        } else if (fileExtension.toLowerCase() === 'xlsx' || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'csv') {
            return <ExcelViewer filePath={filePathComplete} fileName={fileNameComplete}></ExcelViewer>
        } else if (fileExtension.toLowerCase() === 'txt' ) {
            return <TextViewer filePath={filePathComplete} fileName={fileNameComplete}></TextViewer>
        } else {
            return <div>
                {filePathComplete && (
                    <div style={{ marginTop: 10 }}>
                        <a href={filePathComplete} download target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#007bff' }}>
                            ⬇️ Download Arquivo - {fileNameComplete}
                        </a>
                    </div>
                )}
                <p>Visualização não suportada para este tipo de arquivo.</p>;
            </div>
        }
    };

    return (
        <div>
            {!disabled && (
                <DivFiles {...getRootProps()} >
                    <input {...getInputProps()} />
                    <p>Arraste e solte arquivos aqui ou clique para selecionar</p>
                </DivFiles>
            )}

            {files && files.length > 0 && (
                <div>
                    {files.map((file, index) => (
                        <Row key={index}>
                            <Col md="12" xs="12">
                                <a onClick={(event) => { event.preventDefault(); handlePreviewModal(file); }} style={{ cursor: 'pointer', color: 'blue' }}>
                                    {decodeURIComponent(escape(file.originalname))}
                                </a>
                                <a href={`${process.env.PUBLIC_URL}/uploads/${file.filename}`} download={decodeURIComponent(escape(file.originalname))} target="_blank" style={{ margin: '0px 1vw'}}>
                                    <IconComponent icon="MdCloudDownload"/>
                                </a>
                                {(!disabled && !disabledDelete) && (
                                    <DeleteButton variant="outline-danger" onClick={() => handleDeleteFile(file, index)} style={{ margin: '0px 1vw'}}></DeleteButton>
                                )}
                            </Col>
                        </Row>
                    ))}
                </div>
            )}

            <ModalPreview show={previewModalShow} onHide={hidePreviewModal} dialogClassName="custom-modal">
                <Modal.Header closeButton={true}>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body dialogClassName="custom-modal">{selectedFile && renderFilePreview()}</Modal.Body>
            </ModalPreview>
        </div>
    );
}

const getFileExtension = (filename) => {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
};

const isImageFile = (fileExtension) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
    return imageExtensions.includes(fileExtension.toLowerCase());
};

export default UploadFiles;
